import { KTUtil } from "../../../_metronic/_assets/js/components/util";
import KTLayoutQuickPanel from "../../../_metronic/_assets/js/layout/extended/quick-panel";

export const initIds = (ids) => {
  KTUtil.ready(function() {
    for (let id of ids) KTLayoutQuickPanel.init(id);
  });
};
